import { shiftParticipantEntityName, } from '../../../../backend/features/shift/shared';
import { getActiveAccountsFilter } from '@juvare/contact-management/backend/features/permissions/shared';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import React from 'react';
export const useVolunteersTableStaticFilter = (extendedAccountFilter = [], shift, participants) => {
    const userState = useUserState();
    const activeAccountFilter = getActiveAccountsFilter(userState);
    const overlappingAccountFilter = React.useMemo(() => shift
        ? [
            {
                op: 'not-in',
                idSubFilter: {
                    entity: shiftParticipantEntityName,
                    column: 'participantId',
                    filter: [
                        { column: 'status', op: '=', value: 'approved' },
                        { column: 'shiftStartTime', op: '<', value: shift.columns.stopTime },
                        { column: 'shiftStopTime', op: '>', value: shift.columns.startTime },
                        { column: 'shiftId', op: '!=', value: shift.id },
                    ],
                },
            },
        ]
        : [], [shift]);
    const alreadyParticipantsFilter = React.useMemo(() => (participants === null || participants === void 0 ? void 0 : participants.rows)
        ? [
            {
                id: participants.rows.map((participant) => participant.columns.participantId),
                op: 'not-in',
            },
        ]
        : [], [participants === null || participants === void 0 ? void 0 : participants.rows]);
    const staticFilter = React.useMemo(() => [...activeAccountFilter, ...overlappingAccountFilter, ...extendedAccountFilter, ...alreadyParticipantsFilter], [activeAccountFilter, alreadyParticipantsFilter, extendedAccountFilter, overlappingAccountFilter]);
    return { staticFilter };
};
